export const IconCached = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconCached_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconCached_svg__a)">
        <path d="M12.05 20q-3.35 0-5.7-2.325T4 12v-.175l-.9.9a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275.95.95 0 0 1-.275-.7q0-.425.275-.7l2.6-2.6q.3-.3.7-.3t.7.3l2.6 2.6a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-.9-.9V12q0 2.5 1.762 4.25T12.05 18q.401 0 .787-.05.388-.05.763-.175.425-.125.8.025t.575.525q.2.4.037.788a.87.87 0 0 1-.587.512q-.575.2-1.175.288t-1.2.087m-.1-14q-.401 0-.787.05a4 4 0 0 0-.763.175 1.23 1.23 0 0 1-.813-.025A1.1 1.1 0 0 1 9 5.675a.85.85 0 0 1-.038-.763.86.86 0 0 1 .563-.512q.6-.2 1.2-.3T11.95 4q3.35 0 5.7 2.325T20 12v.175l.9-.9a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-2.6 2.6q-.3.3-.7.3a.96.96 0 0 1-.7-.3l-2.6-2.6a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275l.9.9V12q0-2.5-1.762-4.25T11.95 6" />
      </g>
    </svg>
  );
};
